import React, { useState }  from 'react';

import { About } from './components';
import SecondStep from './SecondStep';
import Container from 'components/Container';
import { Main } from 'layouts';
import secondStepData from './secondStepData';


const CareerListingMinimal = ({handleCurrentStep, secondState, initialState}) => {

  return (

  <SecondStep handleCurrentStep={handleCurrentStep} 
  initialState={initialState}
  secondState = {secondState}/>

);
};


export default CareerListingMinimal;
